function doLocalVideo() {
  if (customElements.get("local-video")) return null

  class LocalVideo extends HTMLElement {
    constructor() {
      super()

      this.videoDesktop = this.querySelector(".video-desktop")
      this.videoMob = this.querySelector(".video-mob")
      this.playButton = this.querySelector(".localVideo-play")
      this.stopButton = this.querySelector(".localVideo-stop")
      this.volumeButton = this.querySelector(".localVideo-volume")
      this.muteButton = this.querySelector(".localVideo-volume-mute")
      this.images = this.querySelector(".this-images")
      this.snippet = this.querySelector(".snippet-localVideo")

      const requiredVariables = [
        this.videoDesktop,
        this.videoMob,
        this.playButton,
        this.stopButton,
        this.images,
        this.snippet,
      ]

      let isNull = false
      requiredVariables.forEach((variable) => {
        if (variable == null) {
          isNull = true
          // console.log(
          //   `doLocalVideo: one of the required variables is null`,
          //   requiredVariables
          // )
        }
      })
      if (isNull) return undefined

      this.init()
    }

    init() {
      const playerElement = checkWindowSize("mediumUp")
        ? this.videoDesktop
        : this.videoMob
      const player = videojs(playerElement, {
        muted: true,
        loop: playerElement.dataset.autoplay != null ? true : false,
      })

      player.on("ready", () => {
        if (playerElement.dataset.autoplay != null) {
          this.playVideo(player)
        }
        this.playButton.addEventListener("click", () => this.playVideo(player))
        this.stopButton.addEventListener("click", () => this.stopVideo(player))
        this.muteButton &&
          this.muteButton.addEventListener("click", () =>
            this.volumeVideo("unmute")
          )
        this.volumeButton &&
          this.volumeButton.addEventListener("click", () =>
            this.volumeVideo("mute")
          )

        this.createVideoSize()
      })
    }

    playVideo(videoPlayer) {
      this.multiVideosSwiperControls("hide")
      fadeInOrOut(this.images, "hide")
      fadeInOrOut(this.playButton, "hide")
      setTimeout(() => fadeInOrOut(this.stopButton, "show"), 200)
      videoPlayer.play()
    }

    stopVideo(videoPlayer) {
      this.multiVideosSwiperControls("show")
      fadeInOrOut(this.images, "show")
      fadeInOrOut(this.stopButton, "hide")
      setTimeout(() => fadeInOrOut(this.playButton, "show"), 200)
      videoPlayer.pause()
    }

    /**
     *
     * @param {String} action ['mute', 'unmute']
     * @returns void
     */
    volumeVideo(action) {
      const playerMuteControl = this.querySelector(".vjs-mute-control")
      if (playerMuteControl == null) return null

      if (action === "unmute" && playerMuteControl.title === "Unmute") {
        $(playerMuteControl).trigger("click")
        fadeInOrOut(this.muteButton, "hide")
        setTimeout(() => fadeInOrOut(this.volumeButton, "show"), 200)
        return
      }

      $(playerMuteControl).trigger("click")
      fadeInOrOut(this.volumeButton, "hide")
      setTimeout(() => fadeInOrOut(this.muteButton, "show"), 200)
      return
    }

    createVideoSize() {
      const playerElement = checkWindowSize("mediumUp")
        ? this.videoDesktop
        : this.videoMob
      const playerHeight = parseFloat(playerElement.dataset.height)
      const playerWidth = parseFloat(playerElement.dataset.width)

      if (
        playerHeight == null ||
        playerWidth == null ||
        this.snippet.dataset.design == "removeRelative"
      )
        return null

      const ratioPercentage = (playerHeight / playerWidth) * 100
      this.snippet.style.paddingTop = ratioPercentage + "%"
    }

    multiVideosSwiperControls(action) {
      const swiperVideoWrapper = this.closest(".this-video-wrapper")
      if (swiperVideoWrapper == null) return null
      const swiperControls = [
        swiperVideoWrapper.querySelector(".carousel-nextprev"),
        swiperVideoWrapper.querySelector(".multiVideo-carousel-pagination"),
      ]

      swiperControls.forEach((element) => {
        if (element == null) return null
        if (action === "hide") {
          element.style.opacity = 0
        }
        if (action === "show") {
          element.style.opacity = 1
        }
      })
    }
  }

  customElements.define("local-video", LocalVideo)
}
doLocalVideo()

/**
 * returns null if mediaQuery is $x
 * @param {String} mediaQuerySize ["mediumDown", //addMore]
 */
function checkWindowSize(mediaQuerySize) {
  let windowWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth

  if (mediaQuerySize === "mediumDown") {
    // the start of large is the end of medium
    if (windowWidth < window.mediaQuery.large - 1) return true
  }

  if (mediaQuerySize === "mediumUp") {
    // mediumUp is the end of medium which is the start of large
    if (windowWidth > window.mediaQuery.large) return true
  }
  return false
}

function fadeInOrOut(element, action, displayStyle = "block") {
  if (!element instanceof Element || element == null) return null
  if (action === "hide") {
    element.style.opacity = 0

    setTimeout(() => {
      element.style.display = "none"
    }, 200)
    return
  }

  element.style.display = displayStyle
  setTimeout(() => {
    element.style.opacity = 1
  }, 100)
}
